import { IApplicationState } from '../../types/redux';

export const selectNewbuildingSeoLinkUrl = (state: IApplicationState) =>
  state.calculator.initialFormState.newbuildingSeoLinkUrl;
